/** Eternal City copy, fr. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityFr: Record<string, string> = {
  'city.seoDescription': 'Allez dans une ville vivante. Tout le monde suit une routine quotidienne. Suivez-les, parlez-leur, et passez une journée avec les gens qui vivent sans vous.',
  'city.intro': 'Une ville vivante. Tout le monde ici garde une routine quotidienne, et le temps passe pendant que vous jouez. Cliquez sur la carte pour marcher, ou utilisez les listes à côté.',
  'city.back': 'Retour sur le globe',
  'city.connecting': 'Ouvrir les portes de la ville...',
  'city.reconnecting': 'J\'ai perdu le fil.',
  'city.offline': 'La ville est hors de portée.',
  'city.signinTitle': 'Inscrivez-vous pour entrer',
  'city.signinBody': 'Votre place dans la ville, votre journal et les gens que vous avez rencontrés sont enregistrés pour votre compte.',
  'city.signinCta': 'Inscrivez-vous',
  'city.privacy': 'Comment nous traitons ces données: Politique de confidentialité',
  'city.blocked': 'Si vous pensez que c\'est une erreur, veuillez contacter l\'assistance.',
  'city.openElsewhere': 'Cette ville est ouverte dans une autre tablette.',
  'city.canvasLabel': 'Carte isométrique de {city}. Utilisez les listes à côté pour parler, marcher et regarder autour de vous.',
  'city.hint': 'Cliquez sur le sol pour marcher, ou cliquez sur une personne pour parler.',
  'city.holiday': 'Aujourd\'hui: {name}',
  'city.here': 'Vous êtes à {place}.',
  'city.commons.empty': 'C\'est un espace partagé, et aucun autre voyageur n\'est ici en ce moment.',
  'city.commons.here.one': 'C\'est un espace partagé, et un autre voyageur est ici.',
  'city.commons.here.other': 'C\'est un espace partagé. {count} D\'autres voyageurs sont ici.',
  'city.commons.peer': 'un compagnon de voyage',
  'city.crowd.name': 'Citoyens de la ville',
  'city.travel.ride': 'Ride à {place} (environ {n} minutes)',
  'city.wares.now': 'Je vous le dis maintenant: {list}',
  'city.wares.none': 'Rien n\' est prévu à cette heure.',
  'city.wares.few': '{name} (quelques-uns à gauche)',
  'city.wares.last': '{name} (le dernier)',
  'city.places': 'Allez quelque part .',
  'city.goPlace': 'Allez voir . {place}',
  'city.dialogueAnnounce': 'Les choix sont annoncés au fur et à mesure qu\'ils apparaissent.',
  'city.people': 'Qui est là ?',
  'city.peopleNone': 'Personne à la vue.',
  'city.talk': 'Parlez',
  'city.goto': 'Passez par là.',
  'city.away': '{n} des pas en arrière',
  'city.scenes': 'Ça se passe à proximité.',
  'city.watch': 'Rendez-vous avec moi .',
  'city.props': 'Regardez autour de vous .',
  'city.examine': 'Regardez !',
  'city.open': 'Ouvert',
  'city.take': 'Prends-le !',
  'city.menu.open': 'Ouvert {thing}',
  'city.menu.take': 'Prenez ce qui est dans {thing}',
  'city.menu.walkToThing': 'Marchez vers {thing}',
  'city.dialogue': 'Conversation',
  'city.close': 'À proximité',
  'city.leave': 'Arrêtez la conversation.',
  'city.menu.talk': 'Parlez à {name}',
  'city.menu.walkTalk': 'Passez à côté . {name}',
  'city.menu.walkTo': 'Marchez vers {name}',
  'city.menu.walkHere': 'Marchez ici.',
  'city.menu.swimHere': 'Nigez ici.',
  'city.menu.rowHere': 'Rendez-vous ici',
  'city.mount.down': 'Descends de là ! {name}',
  'city.companion.home': 'Envoyez {name} à la maison',
  'city.rumours.title': 'Tableau des rumeurs',
  'city.rumours.none': 'On ne sait pas encore, les gens de la ville parlent ensemble à la taverne et ce qu\'ils disent se trouve ici.',
  'city.rumours.said': 'dit {name}',
  'city.greet.title': 'Connu par son nom',
  'city.greet.callMe': 'Comment les gens de la ville vous appellent-ils ?',
  'city.greet.placeholder': 'Votre nom.',
  'city.greet.none': 'Personne ne vous connaît encore. Arrêtez-vous et parlez à quelqu\'un, et la prochaine fois, ils vous salueront par votre nom.',
  'city.greet.morning.0': 'Le matin. {name}!',
  'city.greet.morning.1': 'Bonjour à vous. {name}.',
  'city.greet.morning.2': 'Je me lève tôt. {name}?',
  'city.greet.afternoon.0': 'Bonsoir. {name}.',
  'city.greet.afternoon.1': 'Bonne journée. {name}!',
  'city.greet.afternoon.2': 'Bienvenue à nouveau. {name}.',
  'city.greet.evening.0': 'Le soir, {name}.',
  'city.greet.evening.1': 'Bonsoir. Je vous en prie. {name}!',
  'city.greet.evening.2': 'En dehors de la maison, {name}?',
  'city.greet.night.0': 'Il est tard pour sortir. {name}.',
  'city.greet.night.1': 'Attention à l\'obscurité. {name}.',
  'city.greet.night.2': 'Je suis toujours là. {name}?',
  'city.greet.morning.0.anon': 'Bonjour, mon ami !',
  'city.greet.morning.1.anon': 'Bonjour à vous.',
  'city.greet.morning.2.anon': 'Tu te lèves tôt, mon ami ?',
  'city.greet.afternoon.0.anon': 'Bonsoir, mon ami.',
  'city.greet.afternoon.1.anon': 'Bonne journée !',
  'city.greet.afternoon.2.anon': 'Bienvenue à nouveau.',
  'city.greet.evening.0.anon': 'Ce soir, mon ami.',
  'city.greet.evening.1.anon': 'Je vous en prie.',
  'city.greet.evening.2.anon': 'À la maison, mon ami ?',
  'city.greet.night.0.anon': 'Il est tard pour sortir, mon ami.',
  'city.greet.night.1.anon': 'Attention au noir.',
  'city.greet.night.2.anon': 'Tu es toujours là, mon ami ?',
  'city.market.title': 'Tableau de marché',
  'city.market.shut': 'Rien n\'est prévu pour l\'instant.',
  'city.market.later': 'Plus tard aujourd\'hui:',
  'city.market.am': '{n} le matin',
  'city.market.pm': '{n} dans l\'après-midi',
  'city.market.eve': '{n} dans la soirée',
  'city.garden.title': 'Parcelles de jardin',
  'city.garden.tend': 'On va faire le complot.',
  'city.garden.tended': 'Tu tires quelques mauvaises herbes et arroses le terrain.',
  'city.garden.already': 'Vous avez déjà pris soin de ce complot aujourd\'hui.',
  'city.garden.tendedNote': 'a été pris en charge aujourd\'hui',
  'city.garden.arrive': 'Les {crop} Voici ce qu\'il y a {stage}.',
  'city.garden.crop.herbs': 'les herbes',
  'city.garden.crop.apples': 'arbres de pommes',
  'city.garden.crop.kitchen': 'les légumes verts de cuisine',
  'city.garden.crop.cabbages': 'les choux et les haricots',
  'city.garden.crop.wheat': 'champs de blé',
  'city.garden.stage.bare': 'à nu pour l\'hiver',
  'city.garden.stage.sown': 'à partir de la date de récolte',
  'city.garden.stage.sprouting': 'éclosion',
  'city.garden.stage.growing': 'bien poussé',
  'city.garden.stage.flowering': 'en fleur',
  'city.garden.stage.ripe': 'matures et prêts',
  'city.garden.stage.harvested': 'récolté pour l\'année',
  'city.fish.title': 'La pêche',
  'city.fish.cast': 'Jetez une ligne',
  'city.fish.go': 'Allez !',
  'city.fish.here': 'Un bon endroit pour pêcher.',
  'city.fish.casting': 'Tu fais une ligne et tu attends.',
  'city.fish.caught': 'Quelque chose mord. {fish}.',
  'city.fish.got.boot': 'On roule dans un vieux sac et on le renvoie.',
  'city.fish.got.weed': 'Seule l\'herbe de la rivière cette fois.',
  'city.fish.got.nothing': 'Rien ne mord, l\'eau garde ses secrets.',
  'city.fish.casts': '{n} les lancements jusqu\'à présent',
  'city.fish.none': 'Les poissons mordent mieux à l\'aube et au crépuscule, et plus au printemps et à l\'automne.',
  'city.fish.spot.bank': 'rive du fleuve',
  'city.fish.spot.jetty': 'débarquement',
  'city.fish.spot.bridge': 'pont de moulin',
  'city.fish.name.perch': 'une perche',
  'city.fish.name.roach': 'un cafard',
  'city.fish.name.trout': 'une truite',
  'city.fish.name.eel': 'une anguille',
  'city.fish.name.pike': 'une pique',
  'city.fish.name.carp': 'une carpe',
  'city.fish.name.minnow': 'un minnow',
  'city.fish.name.crayfish': 'une crevette',
  'city.fish.name.boot': 'une vieille botte',
  'city.fish.name.weed': 'la mauvaise herbe de rivière',
  'city.fish.name.nothing': 'Rien de tout ça.',
  'city.lost.title': 'Perdu et retrouvé',
  'city.lost.none': 'Les habitants de la ville déposent des choses dans les marchés, la place et d\'autres lieux fréquentés.',
  'city.lost.whose': 'appartient à {name}',
  'city.lost.find': 'Trouver {name}',
  'city.lost.spot': 'Il y a quelque chose sur le sol: {thing}',
  'city.lost.pick': 'Réservez . {thing}',
  'city.lost.picked': 'Tu réponds . {thing}. Il semble qu\' il appartient à {name}.',
  'city.lost.give': 'Donner {thing} retour à {name}',
  'city.lost.thanks': '{name} est heureux d\'avoir {thing} Je reviens.',
  'city.lost.thing.glove': 'un gant perdu',
  'city.lost.thing.keys': 'une bague de clés',
  'city.lost.thing.locket': 'un petit médaillon',
  'city.lost.thing.toy': 'un jouet en bois',
  'city.lost.thing.scarf': 'une écharpe en laine',
  'city.lost.thing.purse': 'un sac à main vide',
  'city.lost.thing.spectacles': 'une paire de lunettes',
  'city.lost.thing.letter': 'une lettre pliée',
  'city.lost.thing.ribbon': 'un ruban pour cheveux',
  'city.lost.thing.pipe': 'un tuyau d\'argile',
  'city.records.title': 'Enregistrements municipaux',
  'city.records.peak': 'Le plus occupé aujourd\'hui à {time}, avec {n} Des gens de la ville.',
  'city.records.now': 'À cette heure-ci: {out} À l\'extérieur. {home} à la maison.',
  'city.records.busiest': 'Quartier le plus fréquenté: {district}.',
  'city.records.outTitle': 'Les gens de la ville sortent, par heure.',
  'city.records.seenTitle': 'Les gens que vous avez vus autour de vous, par heure',
  'city.a11y.title': 'L\'accessibilité',
  'city.a11y.text': 'Taille du texte',
  'city.a11y.size1': 'Normalement',
  'city.a11y.size125': 'Grand',
  'city.a11y.size15': 'Le plus grand',
  'city.a11y.stillOff': 'Réduire le mouvement',
  'city.a11y.stillOn': 'Réduction de la motion',
  'city.a11y.contrastOff': 'Contraste élevé',
  'city.a11y.contrastOn': 'Contraste élevé entre les',
  'city.tour.welcome.title': 'Bienvenue à {city}',
  'city.tour.welcome.body': 'Cette ville vit sur sa propre horloge. Les gens se réveillent, travaillent, mangent et dorment que vous regardiez ou non. Voici un bref aperçu.',
  'city.tour.walk.title': 'La marche',
  'city.tour.walk.body': 'Touchez n\'importe quel terrain ouvert pour y marcher, votre robot trouve son propre chemin à travers les murs et les portes.',
  'city.tour.talk.title': 'Je parle',
  'city.tour.talk.body': 'Appuyez sur une personne pour voir son nom et passez- y. Une fois proche, appuyez à nouveau pour parler.',
  'city.tour.menu.title': 'Je regarde de plus près',
  'city.tour.menu.body': 'Sur un ordinateur, cliquez à droite sur n\'importe quoi pour voir ce que vous pouvez faire là-bas, par exemple lire un panneau, vous asseoir ou prendre une chambre.',
  'city.tour.map.title': 'La carte minimale',
  'city.tour.map.body': 'La petite carte dans le coin montre les routes, les quartiers et les personnes à proximité.',
  'city.tour.panel.title': 'Votre panneau',
  'city.tour.panel.body': 'Le panneau latéral indique les personnes à proximité, les lieux que vous avez découverts, vos quêtes, votre journal et plus encore.',
  'city.tour.keys.title': 'Les mouvements',
  'city.tour.keys.body': 'Le bouton du clavier montre tous les mouvements que votre robot connaît.',
  'city.tour.done.title': 'C\' est tout .',
  'city.tour.done.body': 'Profitez ! {city}. Vous pouvez faire cette visite à nouveau depuis le panneau latéral.',
  'city.tour.step': '{n} de {total}',
  'city.tour.next': 'La prochaine .',
  'city.tour.back': 'Retour',
  'city.tour.skip': 'Sautez la visite .',
  'city.tour.finish': 'Commencez à explorer',
  'city.tour.again': 'Retourne dans la ville.',
  'city.found.title': 'Lieux découverts',
  'city.found.count': '{n} de {total}',
  'city.found.none': 'Passez dans un endroit pour l\'ajouter ici.',
  'city.found.new': 'Découverte {place}',
  'city.board.open': 'Lisez le tableau de notes publiques',
  'city.board.hint': 'Des notes laissées par d\'autres voyageurs, une courte de vos propres, pas de liens, et jusqu\'à trois de vos rester à la fois.',
  'city.board.placeholder': 'Écrivez une courte note pour que les autres la trouvent.',
  'city.board.pin': 'Enfonce la note .',
  'city.board.loading': 'En lisant le tableau...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Prenez votre note .',
  'city.board.err.signin': 'Inscrivez-vous pour enfoncer une note.',
  'city.board.err.soon': 'Attends un peu avant d\'enfoncer une autre note.',
  'city.board.err.bad': 'Les notes doivent être de texte ordinaire de 200 caractères maximum, sans liens.',
  'city.board.err.down': 'On ne peut pas contacter le conseil en ce moment.',
  'city.room.rent': 'Prenez une chambre à {place}',
  'city.room.move': 'Déplacez votre chambre à {place}',
  'city.room.yours': 'Votre chambre à {place}',
  'city.room.decorate': 'Mettez quelque chose ici.',
  'city.room.remove': 'Enlevez le {thing}',
  'city.room.leave': 'Donnez votre chambre',
  'city.room.full': 'Votre chambre n\' a pas de place pour plus',
  'city.room.pickTitle': 'Aménagez votre chambre.',
  'city.room.pickHint': 'Choisissez quelque chose à mettre sur cet endroit. Il reste dans votre chambre sur cet appareil.',
  'city.room.kind.rug': 'Un tapis tissé',
  'city.room.kind.candle': 'Une bougie',
  'city.room.kind.flowers': 'Un pot de fleurs',
  'city.room.kind.painting': 'Une peinture',
  'city.room.kind.plant': 'Une plante en pot',
  'city.room.kind.chest': 'Une petite poitrine.',
  'city.room.kind.lantern': 'Une lanterne',
  'city.room.kind.books': 'Quelques livres.',
  'city.busk.lute': '{name} cueille une mélodie brillante à proximité',
  'city.busk.fiddle': '{name} sèche un rouleau animé à proximité',
  'city.busk.pipe': '{name} joue un air lent à proximité',
  'city.busk.drum': '{name} bat une danse à proximité',
  'city.tail.label': 'Suivant {name}',
  'city.tail.title': 'Retour en arrière {name} tout au long de la journée',
  'city.tail.now': 'Je vous en prie . {activity} à {place}',
  'city.tail.unknown': 'Leurs plans pour l\'instant sont inconnus.',
  'city.tail.next': 'Suivant: {place} à {time}, en {h} h {m} min',
  'city.tail.trail': 'Tracé par: {places}',
  'city.tail.stop': 'Arrêtez de me suivre.',
  'city.pins.add': 'Ajoutez une broche',
  'city.pins.tapMap': 'Appuyez sur la carte pour placer votre broche',
  'city.pins.walk': 'Marchez vers cette broche.',
  'city.pins.note': 'Pin à {x}, {y}. Ajoutez une note',
  'city.pins.noteLabel': 'Note d\'affichage',
  'city.pins.remove': 'Retirez cette broche',
  'city.pins.here': 'Fixez cet endroit sur la carte.',
  'city.compass.north': 'Le Nord',
  'city.compass.at': 'x {x}, y {y}, étage {floor}',
  'city.door.prop': 'Appuie la porte',
  'city.door.close': 'Laissez la porte s\'ouvrir',
  'city.door.unlock': 'Déverrouille la porte .',
  'city.door.lock': 'Fermez la porte !',
  'city.books.browse': 'Parcourez l\' étagère',
  'city.books.shelf': 'Étagère à {place}',
  'city.books.book': 'Le livre',
  'city.books.scroll': 'Rouleau',
  'city.books.prev': 'Précédent',
  'city.books.back': 'Retour à l\' étagère',
  'city.books.next': 'La prochaine .',
  'city.books.page': 'Page {n} de {of}',
  'city.sign.readSign': 'Lisez le panneau.',
  'city.sign.readPlaque': 'Lisez la plaque',
  'city.sign.sign': 'Un panneau peint',
  'city.sign.plaque': 'Une plaque près de la porte',
  'city.district.entering': 'Je suis entré .',
  'city.district.riverside': 'Le bord de la rivière et les marchés bas',
  'city.district.sunwalk': 'Sunwalk',
  'city.district.lanes': 'Les lanes',
  'city.district.monastery': 'Le monastère',
  'city.district.castle': 'Le château',
  'city.district.drains': 'Les vieux drains',
  'city.district.farmlands': 'Les terres agricoles',
  'city.photo.enter': 'Mode photo',
  'city.photo.hint': 'Mode photo: faites glisser pour regarder autour de vous, prenez une capture d\'écran pour la conserver.',
  'city.photo.leave': 'Laissez le mode photo',
  'city.building.who': 'Qui vit et travaille à {place}',
  'city.building.live': 'Il vit ici.',
  'city.building.work': 'Ça marche ici.',
  'city.building.now': 'À l\'intérieur maintenant',
  'city.building.rooms': 'Elle prend le relais {list}.',
  'city.inspect.about': 'À propos de {name}',
  'city.inspect.close': 'À proximité',
  'city.inspect.unknown': 'Personne ne peut vous en dire beaucoup. {name}.',
  'city.inspect.home': 'À la maison',
  'city.inspect.work': 'Travail',
  'city.inspect.none': 'Aucun connu',
  'city.inspect.today': 'Aujourd\'hui',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Suivez {name} tout au long de la journée',
  'city.overlay.label': 'Les superpositions de cartes',
  'city.overlay.crowd': 'Les foules',
  'city.overlay.light': 'Lumière',
  'city.overlay.noise': 'Le bruit',
  'city.bar.pop': '{n} Il vit ici.',
  'city.bar.out': '{n} Sortez !',
  'city.bar.season.spring': 'Le printemps',
  'city.bar.season.summer': 'L\'été',
  'city.bar.season.autumn': 'L\'automne',
  'city.bar.season.winter': 'L\'hiver',
  'city.notebook.title': 'J\'ai entendu et appris',
  'city.notebook.all': 'Tout le monde',
  'city.notebook.heard': 'J\'ai entendu',
  'city.notebook.learned': 'J\'ai appris',
  'city.notebook.search': 'Recherchez vos notes.',
  'city.notebook.none': 'Il n\'y a rien à noter, écoutez dans la rue et parlez aux gens.',
  'city.ask.title': 'Demandez-moi .',
  'city.ask.pick': 'Vous cherchez qui ?',
  'city.ask.ask': 'Demandez',
  'city.ask.passerby': 'Un passant .',
  'city.ask.nobody': 'Il n\'y a personne assez proche pour demander.',
  'city.ask.unseen': '{asker} n\'a pas vu {who} Aujourd\'hui.',
  'city.ask.here': '{asker} dit {who} est proche {place}.',
  'city.ask.go': 'Allez voir . {who}',
  'city.weather.clear': 'Le ciel est clair.',
  'city.weather.cloudy.light': 'Quelques nuages.',
  'city.weather.cloudy.heavy': 'Le gris et nuageux',
  'city.weather.rain.light': 'Une légère pluie',
  'city.weather.rain.heavy': 'Une pluie torrentielle',
  'city.weather.fog.light': 'La brume du matin',
  'city.weather.fog.heavy': 'Les épaisses brumes',
  'city.weather.snow.light': 'Neige légère',
  'city.weather.snow.heavy': 'Neige lourde',
  'city.lamplighter.name': 'L\'éclairage',
  'city.lamplighter.lighting': 'allumage des lampes de rue',
  'city.lamplighter.dousing': 'éteindre les lampes de rue',
  'city.hourglass.title': 'Une montre de sable',
  'city.hourglass.stop': 'Arrêtez la journée.',
  'city.hourglass.paused': 'La journée est immobile.',
  'city.hourglass.resume': 'Allez-y !',
  'city.seat.bench': 'banc',
  'city.seat.chair': 'chaise',
  'city.seat.sit': 'Asseyez-vous sur le {what}',
  'city.inside.crate': 'boîte',
  'city.inside.barrel': 'baril',
  'city.inside.title': 'À l\'intérieur du {what}',
  'city.inside.look': 'Regardez dans le {what}',
  'city.inside.holds': 'C\' est vrai . {fill}: {list}.',
  'city.factions.title': 'Je me tiens dans la ville.',
  'city.factions.wary': 'Attention !',
  'city.factions.unknown': '- Je ne sais pas',
  'city.factions.noticed': 'Noté',
  'city.factions.trusted': 'On lui fait confiance.',
  'city.factions.honored': 'On l\'a honoré.',
  'city.factions.done': 'Les commandes faites: {n}.',
  'city.mail.title': 'Les lettres',
  'city.mail.none': 'Pas de lettres encore.',
  'city.mail.from': 'À partir de {name}',
  'city.mail.waiting': 'En attendant une réponse de {names}.',
  'city.mail.nobody': 'Aidez quelqu\'un à faire une tâche et vous pouvez lui écrire.',
  'city.mail.write': 'Écrivez une lettre .',
  'city.mail.to': 'À qui ?',
  'city.mail.subject': 'Sujet de l\'enquête',
  'city.mail.body': 'Votre lettre',
  'city.mail.send': 'Envoyez-le !',
  'city.mail.untitled': 'Quelques lignes .',
  'city.moth.title': 'Le plateau de la motte',
  'city.moth.trade': 'Faites-moi une faveur .',
  'city.moth.yours': 'C\'est à vous maintenant.',
  'city.spy.title': 'Travail silencieux',
  'city.cut.skip': 'Skip',
  'city.party.title': 'Jouez ensemble.',
  'city.party.blurb': 'Commencez une fête et partagez son code avec vos amis.',
  'city.party.start': 'Démarrer une fête .',
  'city.party.codeLabel': 'Code du parti',
  'city.party.join': 'Rejoignez-moi',
  'city.party.bad': 'Un code de fête est constitué de quatre à huit lettres ou chiffres.',
  'city.party.code': 'Votre code de fête est {code}. Partagez-le avec vos amis pour qu\'ils puissent vous rejoindre.',
  'city.party.alone': 'Personne d\'autre de votre parti n\'est dans la ville en ce moment.',
  'city.party.here': 'juste à côté de toi',
  'city.party.away': '{n} des pas {dir}',
  'city.party.floor': '(étage) {n})',
  'city.party.go': 'Allez voir .',
  'city.party.leave': 'Quittez la fête.',
  'city.party.dir.east': 'à l\'est',
  'city.party.dir.south-east': 'sud-est',
  'city.party.dir.south': 'du sud',
  'city.party.dir.south-west': 'sud-ouest',
  'city.party.dir.west': 'à l\'ouest',
  'city.party.dir.north-west': 'nord-ouest',
  'city.party.dir.north': 'le nord',
  'city.party.dir.north-east': 'Nord-est',
  'city.print.title': 'Imprimez un bâtiment',
  'city.print.here': '{name}: {w} par {d} cellules, étages: {n}. Gardez-le comme un STL pour une imprimante 3D.',
  'city.print.none': 'Restez à côté d\'un bâtiment pour le conserver comme un STL pour une imprimante 3D.',
  'city.print.model': 'Réservoir STL, échelle de modèle (5 mm par cellule)',
  'city.print.tabletop': 'Enregistrer STL, échelle de table (1 pouce par cellule)',
  'city.print.note': 'Des murs, des étages, des portes, des escaliers et des fenêtres que la ville dessine, sur une plaque de base pour qu\'il imprime en une seule pièce.',
  'city.print.models': 'Figures et accessoires, prêts à être imprimés:',
  'city.print.busy': 'Je me prépare...',
  'city.print.model.figure': 'Figure de marcheur, 28 mm sur une base de 25 mm',
  'city.print.model.fountain': 'Fontaine, 3 pouces de large',
  'city.print.model.castle-wall': 'Partie du mur du château, de 3 pouces de long',
  'city.editor.stl': 'Réservez STL',
  'city.editor.title': 'Éditeur de carte de la ville',
  'city.editor.blurb': 'Peindre un plancher de carte de la ville par plancher: murs, rues, portes, eau, échelles et lieux nommés.',
  'city.editor.name': 'Nom de carte',
  'city.editor.tools': 'Les outils',
  'city.editor.tool.pen': 'Pignon',
  'city.editor.tool.rect': 'Blocage',
  'city.editor.tool.room': 'Chambre',
  'city.editor.tool.fill': 'Remplissez',
  'city.editor.tool.spawn': 'Point de départ',
  'city.editor.tiles': 'Terre',
  'city.editor.letter': 'La lettre',
  'city.editor.placeName': 'Nom du lieu',
  'city.editor.addPlace': 'Ajoutez de la place',
  'city.editor.placeBad': 'Un endroit a besoin d\'une lettre et d\'un nom.',
  'city.editor.floors': 'Les étages',
  'city.editor.addFloor': 'Ajout d\'étage',
  'city.editor.map': 'Carte',
  'city.editor.width': 'Largeur',
  'city.editor.height': 'La hauteur',
  'city.editor.new': 'Nouvelle carte',
  'city.editor.undo': 'Défautée',
  'city.editor.export': 'Export',
  'city.editor.import': 'Les importations',
  'city.editor.loaded': 'La carte est chargée.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'Vérifiez',
  'city.editor.ok': 'Il est clair. {walk} cellules ouvertes, {reach} accessible depuis le point de départ.',
  'city.editor.placeSpots': '{name}: {n} cellules',
  'city.editor.canvas': 'Tape de carte',
  'city.spy.take': 'Prends-le !',
  'city.spy.again': 'Essayez encore .',
  'city.spy.drop': 'Laisse tomber .',
  'city.spy.progress': '{n} Pourcentage là-bas.',
  'city.spy.carrying': 'Vous avez le billet.',
  'city.spy.underway': 'En route.',
  'city.spy.done': 'C\'est terminé.',
  'city.spy.failed': 'La dernière fois, c\'était faux.',
  'city.menu.look': 'Regardez ! {thing}',
  'city.menu.street': 'La rue',
  'city.menu.wall': 'Un mur',
  'city.continue': 'Continuer',
  'city.goodbye': 'Au revoir !',
  'city.board.title': 'Tableau de récompense',
  'city.arrive.rooftops': 'Vous vous faites monter sur les toits, les allées s\'ouvrent sous vous et les planches entre les maisons se creusent sous les pieds.',
  'city.arrive.museumRoof': 'Vous faites monter l\'ivre sur le toit du musée et Sunwalk Plaza s\'étend sous vous comme une planche à jeux.',
  'city.crier.title': 'Le drap du criant',
  'city.crier.today': 'Aujourd\'hui est {name}.',
  'city.crier.tomorrow': '{name} C\'est demain.',
  'city.crier.coming': '{name} dans {n} Des jours.',
  'city.crier.stalls': 'Sur les stands à la première lumière du jour:',
  'city.crier.notices': '{n} des avis sur le plateau de récompense.',
  'city.crier.talk': 'On parle de la ville:',
  'city.crier.now': 'Ce qui se passe dans la ville en ce moment:',
  'city.board.empty': 'Rien n\'est fixé aujourd\'hui.',
  'city.board.posted': 'Publié par {name}.',
  'city.board.postedAt': 'Publié par {name}, maintenant à {place}.',
  'city.board.days': '{n} Il reste encore quelques jours.',
  'city.board.find': 'Trouvez-les !',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'En train de discuter avec {name}',
  'city.journal': 'Le journal',
  'city.journalNone': 'Rien n\'a encore été écrit.',
  'city.quests': 'Rands et fils',
  'city.questNone': 'Pas encore, parlez aux gens.',
  'city.rest': 'Le repos {n} minutes',
  'city.saves.title': 'Jeux sauvegardés',
  'city.saves.slot': 'La fente {n}: {day} {time}, {place}',
  'city.saves.empty': 'Localisation {n}: vide',
  'city.saves.save': 'Gardez ici',
  'city.saves.load': 'Chargement',
  'city.saves.sure': 'Touchez à nouveau pour confirmer',
  'city.saves.hint': 'Un sauvetage maintient la ville telle qu\'elle est: où vous êtes, l\'heure, les gens, les quêtes et les coffres.',
  'city.restHint': 'Laissez passer le temps, vous ne pouvez pas vous reposer autant en une heure.',
  'city.bed.ask': 'Restez éveillés. {bed}?',
  'city.bed.night': 'Huit heures passent pendant que vous dormez, et vous reposez selon les règles de votre système de jeu.',
  'city.bed.sleep': 'Le sommeil',
  'city.bed.notNow': 'Pas maintenant.',
  'city.bed.tired': 'Tu n\'es pas encore fatigué. {n} Des heures.',
  'city.bed.asleep': 'La nuit est passée.',
  'city.bed.offer': 'Restez ici.',
  'city.vitals': 'Santé',
  'city.bed.woke': 'Vous dormez dans {bed} et se réveiller à {time}. {change}',
  'city.bed.change': '{label}: {before} à {after}.',
  'city.bed.noRest': 'Les {system} Les règles ne donnent pas de rétablissement pour le repos, donc rien ne répare.',
  'city.bed.beds': 'Des lits',
  'city.bed.demoRules': 'Règles pour l\'essai du lit: {system}. Ajoutez des règles à l\'adresse pour essayer une autre.',
  'city.messages': 'Notes',
  'city.rules': 'Système de jeu',
  'city.rulesNarrative': 'Pas de règles: la ville comme histoire, choisissez un système pour voir tout le monde dans ses chiffres.',
  'city.statsFor': 'Numéros pour',
  'city.sparTitle': 'Bataille d\'entraînement',
  'city.sparA': 'Le premier combattant',
  'city.sparB': 'Deuxième combattant',
  'city.sparVs': 'contre',
  'city.sparRun': 'Le combat',
  'city.sparNote': 'Personne n\'est blessé dans la ville.',
  'city.sparRound': 'Ronde {n}.',
  'city.zoomIn': 'Zoom dans',
  'city.pivot.left': 'Tourner la vue à gauche',
  'city.pivot.right': 'Tourner la vue à droite',
  'city.pivot.north': 'Face au nord',
  'city.zoomOut': 'Zoom à l\' extérieur',
  'city.centre': 'C\' est moi .',
  'city.followOn': 'Suivez',
  'city.followOff': 'Suivez-moi',
  'city.followOnHint': 'La caméra vous suit.',
  'city.followOffHint': 'Tapez-moi pour revenir à vous.',
  'city.minimapShow': 'Afficher la carte',
  'city.minimapHide': 'Masquer la carte',
  'city.minimapOpen': 'Tapez pour l\'ouvrir plus grand.',
  'city.minimapWalk': 'Tapez un endroit pour y marcher.',
  'city.minimapSmall': 'Réduire la carte',
  'city.minimapHint': 'Touchez pour marcher là-bas.',
  'city.chatter.morning.1.a': 'Du pain frais aux fours de coin, si vous avez hâte.',
  'city.chatter.morning.1.b': 'Je l\'ai senti deux rues plus loin.',
  'city.chatter.morning.2.a': 'Vous êtes au lit tôt.',
  'city.chatter.morning.2.b': 'Les cloches m\'ont réveillé.',
  'city.chatter.morning.3.a': 'Les chariots sont entrés par la porte ?',
  'city.chatter.morning.3.b': 'Trois d\'entre eux, et un a perdu une roue sur le pont.',
  'city.chatter.morning.4.a': 'Il fait froid ce matin.',
  'city.chatter.morning.4.b': 'Le brouillard de la rivière disparaîtra à midi.',
  'city.chatter.morning.5.a': 'Où allez-vous ?',
  'city.chatter.morning.5.b': 'Le marché, avant que les bonnes pommes ne disparaissent.',
  'city.chatter.afternoon.1.a': 'Une journée chargée aux stands.',
  'city.chatter.afternoon.1.b': 'Je suis trop occupé.',
  'city.chatter.afternoon.2.a': 'Tu as vu le tanner aujourd\'hui ?',
  'city.chatter.afternoon.2.b': 'Il est descendu à l\'eau il y a une heure.',
  'city.chatter.afternoon.3.a': 'Le soleil est gentil aujourd\'hui.',
  'city.chatter.afternoon.3.b': 'La pluie arrive, je la sens dans mon genou.',
  'city.chatter.afternoon.4.a': 'Que voulait le marchand de poissons pour les anguilles ?',
  'city.chatter.afternoon.4.b': 'J\'ai acheté des céréales à la place.',
  'city.chatter.afternoon.5.a': 'C\'est une nouvelle voiture ?',
  'city.chatter.afternoon.5.b': 'C\'est nouveau pour moi, les roues crient encore comme l\'ancienne.',
  'city.chatter.evening.1.a': 'Tu rentres déjà ?',
  'city.chatter.evening.1.b': 'Le souper ne va pas cuire par lui-même.',
  'city.chatter.evening.2.a': 'Les lampes sont en train de s\'allumer.',
  'city.chatter.evening.2.b': 'Je suis encore en retard.',
  'city.chatter.evening.3.a': 'Tu seras à la taverne ce soir ?',
  'city.chatter.evening.3.b': 'Si ma femme me le permet, oui.',
  'city.chatter.evening.4.a': 'Une longue journée.',
  'city.chatter.evening.4.b': 'Ils le sont tous, à cette époque de l\'année.',
  'city.chatter.evening.5.a': 'Fermez vos fenêtres ce soir.',
  'city.chatter.evening.5.b': 'Je le fais toujours, le vent les secoue quand même.',
  'city.chatter.night.1.a': 'Qui va là-bas ?',
  'city.chatter.night.1.b': 'Juste moi, pose cette lanterne.',
  'city.chatter.night.2.a': 'Vous devriez être endormi.',
  'city.chatter.night.2.b': 'Tu devrais aussi, mon ami.',
  'city.chatter.night.3.a': 'Avez-vous entendu quelque chose près de l\'eau ?',
  'city.chatter.night.3.b': 'C\'est toujours des chats.',
  'city.chatter.night.4.a': 'Une nuit tranquille.',
  'city.chatter.night.4.b': 'On va continuer comme ça.',
  'city.chatter.any.1.a': 'Vous avez entendu les nouvelles ?',
  'city.chatter.any.1.b': 'Il y a toujours des nouvelles.',
  'city.chatter.any.2.a': 'Bonjour à vous.',
  'city.chatter.any.2.b': 'Et à vous aussi.',
  'city.chatter.any.3.a': 'Mon cousin jure que la vieille tour est hantée.',
  'city.chatter.any.3.b': 'Votre cousin jure beaucoup de choses.',
  'city.chatter.any.4.a': 'Les prix continuent de monter.',
  'city.chatter.any.4.b': 'Et mon salaire ne s\'arrête pas.',
  'city.chatter.any.5.a': 'Attention à la piscine.',
  'city.chatter.any.5.b': 'Il est trop tard.',
  'city.chatter.any.6.a': 'C\'est l\'étranger dont tout le monde parle ?',
  'city.chatter.any.6.b': 'Ne regarde pas, c\'est grossier.',
  'city.chatter.any.7.a': 'Comment va ta mère ?',
  'city.chatter.any.7.b': 'C\'est mieux, merci, elle me reprend.',
  'city.chatter.any.8.a': 'Je vous dois un verre, n\'est-ce pas ?',
  'city.chatter.any.8.b': 'Deux, selon mon compte.',
  'city.inventory.title': 'Votre sac',
  'city.inventory.subtitle': 'Montkelian sac à main',
  'city.inventory.close': 'Fermez votre sac',
  'city.inventory.tabs': 'Les sections d\'emballage',
  'city.inventory.tab.inventory': 'Inventaire',
  'city.inventory.tab.journal': 'Le journal',
  'city.inventory.tab.map': 'Carte',
  'city.inventory.empty': 'Vos bagages sont vides, les objets que vous trouverez dans vos voyages seront stockés dans ces poches.',
  'city.inventory.slots': 'Poches',
  'city.inventory.slotEmpty': 'Poche {n}, vide',
  'city.inventory.slot.headgear': 'Coupe de tête',
  'city.inventory.slot.helmet': 'Casque',
  'city.inventory.slot.hat': 'Chapeau',
  'city.inventory.slot.hood': 'La casquette',
  'city.inventory.slot.amulet': 'Amulettes',
  'city.inventory.slot.cloak': 'Chapeau',
  'city.inventory.slot.tabard': 'Tabard',
  'city.inventory.slot.pelt': 'La peau',
  'city.inventory.slot.armor': 'L\' armure',
  'city.inventory.slot.plate': 'Plaque',
  'city.inventory.slot.robe': 'La robe',
  'city.inventory.slot.jerkin': 'Je suis un connard.',
  'city.inventory.slot.hide': 'On se cache .',
  'city.inventory.slot.girdle': 'Les étoiles et les étoiles',
  'city.inventory.slot.belt': 'Ceinture',
  'city.inventory.slot.bracers': 'D\'autres appareils électriques',
  'city.inventory.slot.gloves': 'Des gants',
  'city.inventory.slot.mainHand': 'Main main',
  'city.inventory.slot.offHand': 'Je ne peux pas le faire.',
  'city.inventory.slot.twoHand': 'Les deux mains.',
  'city.inventory.slot.sword': 'L\'épée',
  'city.inventory.slot.shield': 'Le bouclier',
  'city.inventory.slot.staff': 'Le personnel',
  'city.inventory.slot.focus': 'Concentrez-vous',
  'city.inventory.slot.ring': 'Une bague',
  'city.inventory.slot.leggings': 'Les légings',
  'city.inventory.slot.greaves': 'Les Greaves',
  'city.inventory.slot.boots': 'Les bottes',
  'city.inventory.item.sword': 'L\'épée',
  'city.inventory.item.shield': 'Le bouclier',
  'city.inventory.item.knife': 'Couteau',
  'city.inventory.item.axe': 'Une hache',
  'city.inventory.item.tabard': 'Tabard',
  'city.inventory.item.cape': 'Cap',
  'city.inventory.item.ring': 'Une bague',
  'city.inventory.class.default': 'voyageur',
  'city.inventory.class.fighter': 'chasseur',
  'city.inventory.class.paladin': 'Paladine',
  'city.inventory.class.berserker': 'le berserker',
  'city.inventory.class.wizard': 'le magicien',
  'city.inventory.class.rogue': 'débauché',
  'city.inventory.slotFree': 'Vacu',
  'city.inventory.gear': 'Ce que vous portez',
  'city.inventory.view': 'Le spectacle',
  'city.inventory.viewGear': 'Usé',
  'city.inventory.viewPockets': 'Poches',
  'city.inventory.avatarHint': 'Choisissez un autre avatar dans le menu, sous Avatar.',
  'city.inventory.soon.journal': 'Votre journal est vide pour l\'instant.',
  'city.inventory.soon.map': 'Votre carte pliée sera conservée ici, marquée avec les endroits où vous avez été.',
  'city.inventory.hint': 'Appuyez-vous pour ouvrir votre sac',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Choisissez votre avatar',
  'city.avatar.robot': 'Un robot',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladin',
  'city.avatarCloth': 'Tissu',
  'city.avatarClothHint': 'Les capes et les tabards s\' osent au fur et à mesure que vous bougez.',
  'city.soundOn': 'Allumez le son.',
  'city.soundOff': 'Éteignez le son',
  'city.musicOn': 'Jouez de la musique',
  'city.musicOff': 'Arrêtez la musique.',
  'city.walkSpeed': 'Vitesse',
  'city.walkSpeedLabel': 'Vitesse de marche',
  'city.walkSpeedValue': '{n}x',
  'city.me': 'moi aussi',
  'city.quality': 'Qualité',
  'city.qualityAuto': 'Automobile ({tier})',
  'city.tier.low': 'Faible',
  'city.tier.medium': 'Moyenne',
  'city.tier.high': 'En haut',
  'city.robot.keys': 'Les clés de robot',
  'city.robot.title': 'Les clés de robot',
  'city.robot.intro': 'Appuyez sur une touche, ou appuyez ici, et votre robot l\'affiche pour que tout le monde le voie.',
  'city.robot.close': 'À proximité',
  'city.robot.jumpNote': 'Appuyez à nouveau sur Space pendant que vous êtes en l\'air pour faire le double saut.',
  'city.robot.spellNote': 'En mode sortilège, 1, 2 et 3 sont lancés au lieu d\'attaque.',
  'city.robot.climbNote': 'Vous pouvez aussi monter ou toucher un escalier pour le prendre.',
  'city.robot.walkNote': 'W, A, S et D marchent au nord, à l\'ouest, au sud et à l\'est un pas à la fois.',
  'city.robot.walk.north': 'Marchez vers le nord.',
  'city.robot.walk.west': 'Marcher à l\'ouest',
  'city.robot.walk.south': 'Marcher vers le sud',
  'city.robot.walk.east': 'Marchez à l\'est.',
  'city.stairs.label': 'Prends les escaliers.',
  'city.stairs.up': 'Levez-vous !',
  'city.stairs.down': 'En bas !',
  'city.stairs.goUp': 'Montez un étage .',
  'city.stairs.goDown': 'Descends un étage.',
  'city.robot.toggleNote': 'Mode arme, mode sortilège, Sneak, Dance et Fall Down restent jusqu\'à ce que vous appuyez sur eux à nouveau.',
  'city.robot.typing': 'Les clés ne font rien pendant que vous tapez dans une boîte.',
  'city.robot.inSpell': 'Mode de sortie: {act}',
  'city.robot.otherwise': 'Dans le cas contraire: {act}',
  'city.robot.pad': 'Les actions',
  'city.robot.padShow': 'Afficher le panneau d\'action',
  'city.robot.padHide': 'Cachez le plateau d\'action',
  'city.robot.padTouch': '(pour les écrans tactiles)',
  'city.robot.noLadder': 'Pas d\'escalier ou d\'échelle à proximité.',
  'city.robot.act.jump': 'Sautez',
  'city.robot.act.double-jump': 'Double saut',
  'city.robot.act.dodge': 'Le détour.',
  'city.robot.act.block': 'Bloquer ou défendre',
  'city.robot.act.parry': 'Parry',
  'city.robot.act.weapon-mode': 'Mode d\'armement',
  'city.robot.act.spell-mode': 'Mode de sortie',
  'city.robot.act.slash': 'Les éclats',
  'city.robot.act.thrust': 'Poussée',
  'city.robot.act.flurry': 'Le tourbillon',
  'city.robot.act.cast': 'Le casting',
  'city.robot.act.cast-spell': 'Un sort de sortilège',
  'city.robot.act.megacast': 'Méga-diffusion',
  'city.robot.act.duck': 'Duck !',
  'city.robot.act.sneak': 'Sneak',
  'city.robot.act.sing': 'Je chante',
  'city.robot.act.dance': 'Danser',
  'city.robot.act.barf': 'Le barf',
  'city.robot.act.fall': 'Tu tombes ou tu te lèves',
  'city.robot.act.climb-up': 'Montez en haut.',
  'city.robot.act.climb-down': 'Montez vers le bas.',
  'city.robot.act.hurt': 'Prends un coup .',
  'city.robot.act.kneel': 'À genoux et debout',
  'city.robot.act.bow': 'L\'arc',
  'city.robot.act.cheer': 'Félicitations à la victoire',
  'city.panelShow': 'Panneau d\'affichage',
  'city.phone.menu': 'Le menu',
  'city.phone.close': 'Menus fermés',
  'city.phone.view': 'Carte',
  'city.phone.sound': 'Son et rythme',
  'city.phone.people': 'Trouvez quelqu\'un.',
  'city.phone.more': 'Tout le reste .',
  'city.phone.hint': 'Touchez le sol pour marcher, touchez une personne pour parler.',
  'city.phone.gotIt': 'Je l\'ai compris.',
  'city.panelHide': 'Panneau caché',
  'city.canvasLabel3d': 'Carte de {city} Le panneau répertorie tout le monde et tout ici aussi.',
  'city.dock.label': 'Des gens à trouver',
  'city.dock.go': 'Marchez vers {name}',
  'city.dock.walking': 'Je marche vers {name}',
  'city.dock.toPlace': 'Je marche vers {name} à {place}',
  'city.dock.cancel': 'Touchez le sol pour vous arrêter.',
  'city.rigDebug.open': 'Débogage comment {name} Les mouvements',
  'city.rigDebug.title': 'Débogage du récipient: {name}',
  'city.rigDebug.close': 'À proximité',
  'city.rigDebug.move': 'On se déplace',
  'city.rigDebug.facing': 'Face à face',
  'city.rigDebug.allMoves': 'Tous les mouvements',
  'city.rigDebug.allFacings': 'Toutes les faces',
  'city.rigDebug.cycling': 'Le vélo, {s} s chaque',
  'city.rigDebug.play': 'Jouez',
  'city.rigDebug.pause': 'Une pause',
  'city.rigDebug.back': 'Un pas en arrière.',
  'city.rigDebug.forward': 'Un pas en avant, un cadre.',
  'city.rigDebug.speed': 'Vitesse',
  'city.rigDebug.hint': 'Arrêtez de faire des étapes, tapez à l\'extérieur ou appuyez sur Escape pour fermer.',
  'city.rigDebug.anim.idle': 'Pas de travail',
  'city.rigDebug.anim.walk': 'La marche',
  'city.rigDebug.debug': 'Débogage',
  'city.rigDebug.viewLabel': 'Vue',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Leur valeur est déterminée par la valeur de l\'échantillon.',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'face à face {dir}',
  'city.rigDebug.cell': 'rangée {row}, cadre {col}',
  'city.rigDebug.loading': 'chargement',
  'city.rigDebug.clip': 'Le clip',
  'city.rigDebug.allClips': 'Tous les clips',
  'city.rigDebug.noClips': 'Pas de clips',
  'city.rigDebug.layers': 'Le spectacle',
  'city.rigDebug.show.model': 'Modèle',
  'city.rigDebug.show.bones': 'Les os',
  'city.rigDebug.show.pieces': 'Les pièces',
  'city.rigDebug.boneCount': '{n} les os',
  'city.rigDebug.no3d': 'La vue 3D ne pouvait pas démarrer sur cet écran.',
  'city.rigDebug.hint3d': 'Tirez pour faire tourner la caméra, faites une pause, tapez à l\'extérieur ou appuyez sur Escape pour fermer.',
  'city.rigDebug.standIn': '{name} est affichée sur le {body} Le corps est ici jusqu\'à ce que le sien soit prêt.',
  'city.rigDebug.archive': 'Les archives',
  'city.rigDebug.archivePose': 'Prévisualisation de la pose: voir comment {name} Les mouvements',
  'city.pose.open': 'Voir comment {name} Les mouvements',
  'city.pose.robot': 'Vous (robot remplaçant)',
  'city.pose.you': 'Vous ?',
  'city.pose.see': 'Regardez-les bouger .',
  'city.pose.youTitle': 'Comment vous bougez',
  'city.pose.openYou': 'Regarde comment tu bouges.',
  'city.pose.title': 'Comment ? {name} Les mouvements',
  'city.pose.allTitle': 'Toutes les poses',
  'city.pose.all': 'Montrez toutes les poses',
  'city.pose.one': 'C\' est juste ... {name}',
  'city.pose.close': 'À proximité',
  'city.pose.hint': 'Appuyez à l\'extérieur pour fermer',
  'city.pose.loading': 'Chargement',
  'city.pose.anim.idle': 'Pas de travail',
  'city.pose.anim.walk': 'La marche',
  'city.pose.anim.talk': 'Parlez',
  'city.pose.anim.sit': 'Asseyez-vous',
  'city.pose.anim.run': 'Courir',
  'city.pose.drag': 'Traîner à tourner',
  'city.pose.gait': 'Le mouvement',
  'city.pose.model': '{name} en 3D',
  'city.pose.dir.SW': 'tourné vers le sud-ouest',
  'city.pose.dir.SE': 'tourné vers le sud-est',
  'city.pose.dir.NE': 'tourné vers le nord-est',
  'city.pose.dir.NW': 'tourné vers le nord-ouest',
  'city.demoLink': 'Ouvrez la démo du rendu',
  'city.demoTitle': 'Démo de l\'expérience',
  'city.demoNote': 'Un aperçu local de la ville en 3D avec des marcheurs.',
  'city.demoTime': 'Temps de la journée',
  'city.demoSeason': 'Saison',
  'city.demoPlay': 'Faites fonctionner l\'horloge',
  'city.demoPause': 'Arrêtez l\'horloge.',
  'city.demoTower': 'Tour d\'essai',
  'city.demoTowerNote': 'Un bâtiment de quatre étages pour vérifier ce que vous pouvez voir à l\'intérieur. à l\' intérieur, les étages au-dessus de vous sont coupés et tout ce que vous ne pouviez pas voir de votre position est grisé.',
  'city.demoGoTower': 'Marchez jusqu\'à la tour.',
  'city.demoFloor': 'Le plancher: {floor}',
  'city.demoFloor0': 'Terre',
  'city.demoFloor1': 'Deuxième',
  'city.demoFloor2': 'Le troisième',
  'city.demoFloor3': 'Quatrième',
  'city.demoFloor4': 'Le toit',
  'city.demoWindow': 'La fenêtre du 3e étage',
  'city.demoRoom': 'Chambre intérieure du 3e étage',
  'city.demoUp': 'À l\'étage .',
  'city.demoDown': 'Dans un étage .',
  'city.makeWay.polite': 'Je suis désolé.',
  'city.makeWay.gruff': 'Regarde où tu marches.',
  'city.makeWay.immovable': 'Je ne bouge pas.',
  'city.makeWay.busy': 'Attention à la route.',
  'cascade.seoTitle': 'Débogageur de cascade',
  'cascade.title': 'Débogageur de cascade',
  'cascade.intro': 'Chaque élément qui forme a généré de l\'art, défini comme deux arbres familiaux. Le côté style va du système jusqu\'au directeur artistique. Le côté héritier est toute la taxonomie, de chaque racine à chaque fragment jusqu\'à l\'espèce et les lignées qui les entourent. Ouvrez n\'importe quelle ligne pour lire son texte complet.',
  'cascade.readOnly': 'Rien sur cet écran ne peut changer une requête.',
  'cascade.fetchedAt': 'Lire à partir de l\' API de contenu à {time}',
  'cascade.refresh': 'Lisez encore une fois',
  'cascade.loading': 'Je lis les deux cascades...',
  'cascade.error': 'Je n\'ai pas pu lire les cascades de l\'API de contenu.',
  'cascade.forbidden': 'Cet écran est destiné aux administrateurs du site. Votre compte est connecté mais n\'a pas le rôle d\'administrateur.',
  'cascade.style.title': 'Cascade de style',
  'cascade.style.subtitle': 'Système, éditeur, gamme de produits, réglage, type de média, livre et directeur artistique.',
  'cascade.style.focus': 'Suivez la chaîne pour',
  'cascade.style.counts': '{nodes} lignes de style, {edges} connexions, {media} modèles de médias',
  'cascade.taxa.title': 'Cascade d\'héritiers',
  'cascade.taxa.subtitle': 'Chaque nœud ajoute son propre prompt à tout ce qu\'il hérite des nœuds au-dessus.',
  'cascade.taxa.group': 'Groupe rapide',
  'cascade.taxa.find': 'Trouver un taxon ou une lignée',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, un nom de lignée...',
  'cascade.taxa.counts': '{taxa} les taxons, {prompts} les prompts de taxon, {lineages} lignées',
  'cascade.taxa.shardCounts': '{taxa} les taxons, {prompts} des lignes rapides',
  'cascade.taxa.truncated': 'L\'API de contenu a fermé la liste des requêtes de cette section, donc certaines lignes peuvent manquer ici.',
  'cascade.taxa.emptyShards': 'Les morceaux sans taxon: {names}',
  'cascade.taxa.orphans': 'Des lignées qui pointent vers un taxon qui n\'est pas dans aucun arbre',
  'cascade.taxa.noOwn': 'Pas de préavis pour ce groupe.',
  'cascade.taxa.inherits': 'Des héritiers d\'en haut',
  'cascade.taxa.inheritsNothing': 'Rien d\'hérité, c\'est là que commence la chaîne.',
  'cascade.taxa.through': 'Composé à travers ce nœud',
  'cascade.taxa.lineages': 'Lignées de cette espèce',
  'cascade.level.system': 'Système',
  'cascade.level.publisher': 'Éditeur',
  'cascade.level.product_line': 'Ligne de produits',
  'cascade.level.setting': 'Réglage',
  'cascade.level.media': 'Type de média',
  'cascade.level.book': 'Le livre',
  'cascade.level.art_director': 'Directeur artistique',
  'cascade.empty.system': 'Aucune ligne de style système sur cette chaîne.',
  'cascade.empty.publisher': 'Il n\'existe pas encore de ligne de style d\'éditeur.',
  'cascade.empty.product_line': 'Il n\'y a pas de ligne de style de gamme de produits sur cette chaîne.',
  'cascade.empty.setting': 'Aucune ligne de style sur cette chaîne.',
  'cascade.empty.media': 'Aucun modèle de type multimédia ne s\'applique à cette chaîne.',
  'cascade.empty.book': 'Aucune ligne de style de livre ne dépend de ce cadre.',
  'cascade.empty.art_director': 'Aucun directeur artistique n\'est lié à cette chaîne.',
  'cascade.missing': 'Niveau manquant',
  'cascade.others': 'Autres rangées à ce niveau ({count})',
  'cascade.mediaSpeciesNote': '{count} Les modèles d\'espèces sont affichés sur le côté héritier, sous leur lignée.',
  'cascade.field.id': 'le numéro d\'identification',
  'cascade.field.scope': 'portée',
  'cascade.field.scopeId': 'id de portée',
  'cascade.field.group': 'groupe',
  'cascade.field.mediaType': 'type de média',
  'cascade.field.prompt': 'rapidement',
  'cascade.field.negative': 'négatif',
  'cascade.field.defaults': 'défauts',
  'cascade.field.refs': 'images de référence',
  'cascade.field.chars': '{count} caractères',
  'cascade.field.empty': 'vide',
  'cascade.facet.art_direction': 'Le noyau',
  'cascade.facet.art_direction_character': 'Le caractère',
  'cascade.facet.art_direction_scene': 'Scène',
  'cascade.facet.art_direction_interface': 'Interface',
  'cascade.facet.art_direction_cartography': 'Cartographie',
  'cascade.facet.art_direction_audiobook': 'Livre audio',
  'cascade.facet.art_direction_movie': 'Cinéma',
  'cascade.facet.art_direction_short': 'Courte durée',
  'cascade.facet.art_direction_tvshow': 'Émission télévisée',
  'cascade.composed.title': 'Composé pour {name}',
  'cascade.composed.layers': 'Couches, larges à étroites',
  'cascade.composed.preview': 'Prompts d\'image composés',
  'cascade.composed.previewNote': 'Assemblé sur cet écran à partir des lignes ci-dessus dans l\'ordre en cascade: style de base, facette de caractères, modèles multimédias, traits de taxons, puis la ligne d\'impression le générateur ajoute dans le code.',
  'cascade.composed.negative': 'Négatif composé',
  'cascade.composed.fromCode': 'ajoutés en code, non stockés dans aucune ligne',
  'cascade.flags.duplicates': 'Je l\'ai dit deux fois.',
  'cascade.flags.conflicts': 'Termes négatifs qui apparaissent également dans l\'interrogatoire',
  'cascade.flags.none': 'Pas de phrases répétées et pas de termes négatifs qui vont à l\'encontre de l\'interrogatoire.',
  'cascade.flags.in': 'dans {sources}',
  'cascade.source.styleCore': 'cœur de style',
  'cascade.source.styleCharacter': 'facettes de caractères de style',
  'cascade.source.media': 'modèle multimédia, {scope}',
  'cascade.source.taxon': 'le taxon {rank} {value}',
  'cascade.source.printSafe': 'ligne d\'impression (code)',
  'cascade.rank.domain': 'domaine',
  'cascade.rank.kingdom': 'royaume',
  'cascade.rank.phylum': 'le phylum',
  'cascade.rank.class': 'classe',
  'cascade.rank.ordem': 'l\'ordre',
  'cascade.rank.family': 'famille',
  'cascade.rank.genus': 'le genre',
  'cascade.rank.species': 'espèces',
  'cascade.rank.shard': 'déchets',
}
